import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { PrismStepComponent } from '@shure/prism-angular-components';

import { StepRouter } from '../step-router';

@Component({
	selector: 'sh-step-router-content-outlet',
	standalone: true,
	templateUrl: './step-router-content-outlet.component.html',
	styleUrl: './step-router-content-outlet.component.scss',
	imports: [CommonModule, PrismStepComponent]
})
export class StepRouterContentOutletComponent {
	constructor(protected readonly stepRouter: StepRouter) {}
}
